import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChevronBottom"><Path fillRule="evenodd" clipRule="evenodd" d="M4.00011 7.93945L12.0001 15.9395L20.0001 7.93945L21.0608 9.00011L12.0001 18.0608L2.93945 9.00011L4.00011 7.93945Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronBottom;
